import React from 'react';
import { sanitizeRequestId } from '../utils/errors';
import type { StartupStage, StartupView } from '../utils/startup';

const loadingMessages: Record<StartupStage, string> = {
  config: 'Loading sign-in settings…',
  session: 'Restoring your sign-in session…',
  profile: 'Checking your application access…'
};

export default function StartupStatus({ state, onRetry }: {
  state: StartupView;
  onRetry: (stage: StartupStage) => void;
}) {
  if (state.kind === 'loading') {
    return (
      <section className="card" role="status" aria-live="polite" aria-busy="true">
        <h2>Loading workspace</h2>
        <p>{loadingMessages[state.stage]}</p>
      </section>
    );
  }
  const requestId = sanitizeRequestId(state.failure.requestId);
  return (
    <section className="card" role="alert" aria-labelledby="startup-error-title">
      <h2 id="startup-error-title">{state.failure.title}</h2>
      <p>{state.failure.message}</p>
      {requestId && <p>Request ID: <code style={{ overflowWrap: 'anywhere' }}>{requestId}</code></p>}
      <div className="actions">
        <button onClick={() => onRetry(state.retry)}>
          {state.retry === 'session' ? 'Retry sign-in' : state.retry === 'profile' ? 'Retry access check' : 'Retry loading'}
        </button>
      </div>
    </section>
  );
}
